import { useTranslation } from "@/core/i18n";
import { DescriptiveTag } from "atoms/tag/DescriptiveTag";

type PackageItem = {
  productId: string;
  name: string;
  description: string;
  totalQuantity: number;
  remainingQuantity: number;
};

export const PackageItemCard = ({ item }: { item: PackageItem }) => {
  const { t } = useTranslation();
  const redeemed = item.totalQuantity - item.remainingQuantity;
  const redeemedLabel =
    item.remainingQuantity === 0
      ? t("packageItemCard.redeemed")
      : t("packageItemCard.redeemedCount", { count: redeemed });

  return (
    <div className="flex w-full items-center overflow-hidden rounded-lg border border-l-8 border-l-gray-200 bg-white shadow-subtle">
      <div className="flex flex-1 flex-col overflow-hidden py-2 pl-4 pr-2">
        <div className="flex items-baseline justify-between gap-2">
          <div className="flex items-baseline gap-1">
            {item.totalQuantity > 1 && (
              <span className="font-serif text-body2 font-semibold text-brand-color">
                {item.totalQuantity}x
              </span>
            )}
            <div className="truncate font-serif text-body2 font-semibold">{item.name}</div>
          </div>
          {item.remainingQuantity < item.totalQuantity && (
            <DescriptiveTag size="small" color="secondary">
              {redeemedLabel}
            </DescriptiveTag>
          )}
        </div>
        {item.description && (
          <div className="line-clamp-2 text-body3 text-secondary">{item.description}</div>
        )}
      </div>
    </div>
  );
};
